import React, { useEffect } from 'react';

import { useFranchiseeContext, REPLACE } from '../../context/Franchisee';
interface ContextComponentProps {
  franchisee?: any;
}
const ContextComponent: React.FC<ContextComponentProps> = ({
  franchisee,
}: ContextComponentProps) => {
  const { dispatchFranchisee } = useFranchiseeContext();

  useEffect(() => {
    if (franchisee === undefined) return;
    if (franchisee) {
      dispatchFranchisee({
        type: REPLACE,
        payload: franchisee,
      });
    }
  }, [franchisee]);

  return <div></div>;
};

export default ContextComponent;
